enum DataTestId {
    ActiveBreadcrumb = 'active-breadcrumb',
    AddPaymentMethodButton = 'add-payment-method-button',
    AddPaymentRequestButton = 'add-payment-request-button',
    AddReservationButton = 'add-reservation-button',
    AgeCategoryExtraOccupancyAdjustment = 'age-category-extra-occupancy-adjustment',
    AgeCategoryStandardOccupancyAdjustment = 'age-category-standard-occupancy-adjustment',
    AnotherAccountSearch = 'another-account-search',
    AppNavbar = 'app-navbar',
    ArrivalsStatisticsChart = 'arrivals-statistics-chart',
    ArrivingProfilesStatisticsChart = 'arriving-profiles-statistics-chart',
    AssignPropertiesButton = 'assign-properties-button',
    AssignPropertiesSubmitButton = 'assign-properties-submit-button',
    AssistantAddFavoriteSearch = 'assistant-add-favorite-search',
    AssistantDeleteFavoriteSearch = 'assistant-delete-favorite-search',
    AssistantDeleteRecentSearch = 'assistant-delete-recent-search',
    AssistantFavoriteSearchCard = 'assistant-favorite-search-card',
    AssistantNavbarSearch = 'assistant-navbar-search',
    AssistantRecentSearchCard = 'assistant-recent-search-card',
    AssistantResultShowMore = 'show-more-',
    AttributePriceAdjustmentSubmitButton = 'attribute-price-adjustment-submit-button',
    AvailabilityAdjustmentRelease = 'availability-adjustment-release',
    AvailabilityAdjustmentSave = 'availability-adjustment-save',
    AvailabilityBlockBookingEngineUpselling = 'availability-block-booking-engine-upselling',
    AvailabilityBlockRateEdit = 'availability-block-rate-edit',
    AvailabilityReportBulkAvailabilityAdjustmentButton = 'availability-report-bulk-availability-adjustment-button',
    AvailabilityReportNextDayButton = 'availability-report-next-day-button',
    AvailabilityReportPrevDayButton = 'availability-report-prev-day-button',
    AvailabilityReportShowBlocksButton = 'availability-report-show-blocks-button',
    AvailabilityReportShowGuestInHouseButton = 'availability-report-show-guest-in-house-button',
    AvailabilityReportShowOldOccupancyReportButton = 'availability-report-show-old-occupancy-report-button',
    AvailabilityReportShowRateManagementButton = 'availability-report-show-rate-management-button',
    AvailabilityReportShowReservationsButton = 'availability-report-show-reservations-button',
    BasePriceUpdateButton = 'base-price-update-button',
    BasketAddReservationButton = 'basket-add-reservation-button',
    BillReinstateFormSubmitButton = 'bill-reinstate-form-submit-button',
    BillingAssociateCurrentOwnerCheckbox = 'billing-associate-current-owner-checkbox',
    BillingChargeAndCloseButton = 'billing-charge-and-close-button',
    BillingChargeCreditCardDropdownOption = 'billing-charge-credit-card-dropdown-option',
    BillingChargePreauthorizationDropdownOption = 'billing-charge-preauthorization-dropdown-option',
    BillingInvoiceButton = 'billing-invoice-button',
    BillingIssueInvoice = 'billing-issue-invoice',
    BillingPreviewButton = 'billing-preview-button',
    BillingProformaInvoice = 'billing-proforma-invoice',
    BillingScreenAccountSearch = 'billing-screen-account-search',
    BookNowButton = 'book-now-button',
    CancelFuturePaymentPlanPaymentButton = 'cancel-future-payment-plan-payment-button',
    CancelPaymentPlanButton = 'cancel-payment-plan-button',
    CapitalApplyNowButton = 'capital-apply-now-button',
    CapitalBannerForPayoutReport = 'capital-banner-for-payout-report',
    CapitalBannerForPayoutReportButton = 'capital-banner-for-payout-report-button',
    CapitalCalculatorInput = 'capital-calculator-input',
    CapitalCheckEligibilityButton = 'capital-check-eligibility-button',
    CapitalFAQHowIsYouLendDifferent = 'capital-faq-how-is-youlend-different',
    CapitalFAQWhatInfoDoINeed = 'capital-faq-what-info-do-i-need',
    CapitalFAQWhenWillTheFundsBeReceived = 'capital-faq-when-will-the-funds-be-received',
    CapitalFAQWhoIsYoulend = 'capital-faq-who-is-youlend',
    CentralRateGroupDeleteButton = 'central-rate-group-delete-button',
    CentralRateGroupEditButton = 'central-rate-group-edit-button',
    CheckInAndCreateKeysButton = 'check-in-and-create-keys-button',
    CheckInButton = 'check-in-button',
    CheckOutButton = 'check-out-button',
    ConfirmCancelFuturePaymentPlanPaymentButton = 'confirm-cancel-future-payment-plan-payment-button',
    ConfirmCancelPaymentPlanButton = 'confirm-cancel-payment-plan-button',
    ConfirmChargeAndCloseButton = 'confirm-charge-and-close-button',
    ConfirmDeletePolicyButton = 'confirm-delete-policy-button',
    ConfirmationButton = 'confirmation-button',
    ContinueWithSelectedServiceAndDates = 'continue-with-selected-service-and-dates',
    CreateCancellationPolicy = 'create-cancellation-policy',
    CreatePaymentPlanSubmitButton = 'create-payment-plan-submit-button',
    CreatePaymentPolicy = 'create-payment-policy',
    Customers = 'customers',
    DashboardWidgetAtomizeCampaignButton = 'dashboard-widget-atomize-campaign-button',
    DashboardWidgetDataSecurityButton = 'dashboard-widget-data-security-button',
    DashboardWidgetDayuseButton = 'dashboard-widget-dayuse-button',
    DashboardWidgetDigitalKeyButton = 'dashboard-widget-digital-key-button',
    DashboardWidgetFlexkeepingButton = 'dashboard-widget-flexkeeping-button',
    DashboardWidgetHousekeepingButton = 'dashboard-widget-housekeeping-button',
    DashboardWidgetMewsCommunityButton = 'dashboard-widget-mews-community-button',
    DashboardWidgetMewsUniversityButton = 'dashboard-widget-mews-university-button',
    DashboardWidgetUberButton = 'dashboard-widget-uber-button',
    DeleteCancellationPolicy = 'delete-cancellation-policy',
    DeletePaymentPolicy = 'delete-payment-policy',
    DeparturesStatisticsChart = 'departures-statistics-chart',
    DetailsButton = 'details-button',
    EditCancellationPolicy = 'edit-cancellation-policy',
    EditPaymentPolicy = 'edit-payment-policy',
    EndDate = 'end-date',
    EnterpriseLogo = 'enterprise-logo',
    FloorFilterNewReservationScreen = 'floor-filter-nrs',
    FormMainButton = 'form-main-button',
    InhouseProfilesStatisticsChart = 'inhouse-profiles-statistics-chart',
    InstantPayoutButton = 'instant-payout-button',
    InstantPayoutCancelButton = 'instant-payout-cancel-button',
    InstantPayoutInputField = 'instant-payout-input-field',
    InstantPayoutJoinWaitlistButton = 'instant-payout-join-waitlist-button',
    InstantPayoutProceedToPayoutButton = 'instant-payout-proceed-to-payout-button',
    InstantPayoutWidgetButton = 'instant-payout-widget-button',
    KeyCutterButton = 'key-cutter-button',
    LoyaltyProgramLink = 'loyalty-program-link',
    MakeResourceInspectedButton = 'make-resource-inspected-button',
    MarketplaceApplicationDetailsButton = 'marketplace-application-details-button',
    MarketplaceApplicationDetailsEmailLink = 'marketplace-application-details-email-link',
    MarketplaceApplicationDetailsWebsiteLink = 'marketplace-application-details-website-link',
    MarketplaceBizzonWidgetButton = 'marketplace-bizzon-widget-button',
    MarketplaceBookDigitalKeyDemoButton = 'marketplace-book-digital-key-demo-button',
    MarketplaceBookServiceButton = 'marketplace-book-service-button',
    MarketplaceConnectButton = 'marketplace-connect-button',
    MarketplaceConnectWithExistingAccountButton = 'marketplace-connect-with-existing-account-button',
    MarketplaceDiscoverLink = 'marketplace-discover-link',
    MarketplaceExpediaWidgetButton = 'marketplace-expedia-widget-button',
    MarketplaceFeaturedSection = 'marketplace-featured-section',
    MarketplaceHotelsForTreesWidgetButton = 'marketplace-hotels-for-trees-widget-button',
    MarketplaceIntegrationTryForFreeButton = 'marketplace-integration-try-for-free-button',
    MarketplaceLargeBannerDetailsButton = 'marketplace-large-banner-details-button',
    MarketplaceLovedSection = 'marketplace-loved-section',
    MarketplaceMenuCollapseButton = 'marketplace-menu-collapse-button',
    MarketplaceMenuExpandButton = 'marketplace-menu-expand-button',
    MarketplaceMenuItem = 'marketplace-menu-item',
    MarketplaceNewApplicationSection = 'marketplace-new-application-section',
    MarketplaceOrderTerminalButton = 'marketplace-order-terminal-button',
    MarketplaceOrderTerminalDialogOrderButton = 'marketplace-order-terminal-dialog-order-button',
    MarketplacePurchaseConfirmationDialogCancelButton = 'marketplace-purchase-confirmation-dialog-cancel-button',
    MarketplacePurchaseConfirmationDialogPurchaseButton = 'marketplace-purchase-confirmation-dialog-purchase-button',
    MarketplacePurchaseConfirmationDialogTACCheckbox = 'marketplace-purchase-confirmation-dialog-tac-checkbox',
    MarketplaceRequestApplicationButton = 'marketplace-request-application-button',
    MarketplaceRequestApplicationSendButton = 'marketplace-request-application-send-button',
    MarketplaceSearchField = 'marketplace-search-field',
    MarketplaceSettingsButton = 'marketplace-settings-button',
    MarketplaceSmallApplicationDetailsButton = 'marketplace-small-application-details-button',
    MarketplaceSmsWidgetButton = 'marketplace-sms-widget-button',
    MarketplaceStartTrialButton = 'marketplace-start-trial-button',
    MarketplaceSubscribeButton = 'marketplace-subscribe-button',
    MarketplaceSuccessfulConnectionDialogButton = 'marketplace-successful-connection-dialog-button',
    MarketplaceTerminalOrderWidgetButton = 'marketplace-terminal-order-widget-button',
    MessagesContainer = 'messages-container',
    MfaCode = 'mfa-code',
    MulticurrencySettingsBannerButtonLearnMore = 'multicurrency-settings-banner-button-learn-more',
    MulticurrencySettingsBannerButtonOptIn = 'multicurrency-settings-banner-button-opt-in',
    MulticurrencySettingsFeatureToggleOnline = 'multicurrency-settings-feature-toggle-online',
    MulticurrencySettingsFeatureToggleTerminal = 'multicurrency-settings-feature-toggle-terminal',
    MulticurrencySettingsLinkLearnMore = 'multicurrency-settings-link-learn-more',
    MulticurrencySettingsLinkTermsAndConditions = 'multicurrency-settings-link-terms-and-conditions',
    NNRSNotes = 'nnrs-notes',
    NRSChangeDate = 'nrs-change-date',
    NRSChangeService = 'nrs-change-service',
    NavbarChatButton = 'navbar-chat-button',
    NavbarSearch = 'navbar-search',
    NewCancellationPolicy = 'new-cancellation-policy',
    NewPaymentPolicy = 'new-payment-policy',
    NextButton = 'next-button',
    Occupancy = 'occupancy',
    OccupancyAdjustmentFormUpdateButton = 'occupancy-adjustment-form-update-button',
    OpenAvailabilityBlockDetail = 'open-availability-block-detail',
    OrderStatisticsChart = 'order-statistics-chart',
    OverbookService = 'overbook-service',
    PaymentDetailLink = 'payment-detail-link',
    PaymentMethodClearCardActionButton = 'payment-method-clear-card-action-button',
    PaymentMethodCreateExternalPaymentActionButton = 'payment-method-create-external-payment-action-button',
    PaymentMethodCreateExternalPreauthorizationActionButton = 'payment-method-create-external-preauthorization-action-button',
    PaymentMethodCreateGatewayPaymentActionButton = 'payment-method-create-gateway-payment-action-button',
    PaymentMethodCreateGatewayPreauthorizationActionButton = 'payment-method-create-gateway-preauthorization-action-button',
    PaymentMethodDeleteCardActionButton = 'payment-method-delete-card-action-button',
    PaymentMethodDisableCardActionButton = 'payment-method-disable-card-action-button',
    PaymentMethodLink = 'payment-method-link',
    PaymentPlanIntervalKindOptionCustom = 'payment-plan-interval-kind-option-custom',
    PaymentPlanIntervalKindOptionReservation = 'payment-plan-interval-kind-option-reservation',
    PaymentPreauthExpireFieldMewsTerminal = 'payments-user-preauth-expire-field-mt',
    PaymentRequestCollectPaymentMethodOption = 'payment-request-collect-payment-method-option',
    PaymentRequestCollectPaymentOption = 'payment-request-collect-payment-option',
    PaymentRequestPreauthorizePaymentOption = 'payment-request-preauthorize-payment-option',
    PrimaryReservationButton = 'primary-reservation-button',
    PrivacyPolicyLink = 'privacy-policy-link',
    ProcessExternalPaymentButton = 'process-external-payment-button',
    ProcessPaymentButton = 'process-payment-button',
    ProductCheckListDateTitle = 'pcl-date-title',
    RateAdjustmentOverrideButton = 'rate-adjustment-override-button',
    RateGroupFormManageCentrallyButton = 'rate-group-form-manage-centrally-button',
    RateGroupFormNextButton = 'rate-group-form-next-button',
    RateGroupFormSubmitButton = 'rate-group-form-submit-button',
    RateManagementScreenBasePriceAsideCell = 'rms-base-price-aside-cell',
    RateManagementScreenBasePriceRowCell = 'rms-base-price-row-cell',
    RateManagementScreenOccupancyAsideCell = 'rms-occupancy-aside-cell',
    RateManagementScreenOccupancyRowCell = 'rms-occupancy-row-cell',
    RateManagementScreenPricingAsideCell = 'rms-pricing-aside-cell',
    RateManagementScreenPricingRowCell = 'rms-pricing-row-cell',
    RateManagementScreenRemoveAdjustmentsButton = 'rms-remove-adjustments-button',
    RateManagementScreenTotalOccupancyAsideCell = 'rms-total-occupancy-aside-cell',
    RateManagementScreenTotalOccupancyRowCell = 'rms-total-occupancy-row-cell',
    RebatesItemSelection = 'rebates-item-selection',
    RebatesReasonField = 'rebates-reason-field',
    RebatesReasonForm = 'rebates-reason-form',
    RebatesSelectAll = 'rebates-select-all',
    RebatesSubmitButton = 'rebates-submit-button',
    RebatesSum = 'rebates-sum',
    RefundPaymentActionButton = 'refund-payment-action-button',
    RefundPaymentButton = 'refund-payment-button',
    RefundPaymentSubmitButton = 'refund-payment-submit-button',
    ResDiaryBackToStep1Button = 'resdiary-back-to-step-1-button',
    ResDiaryBackToStep2Button = 'resdiary-back-to-step-2-button',
    ResDiaryCreateBookingButton = 'resdiary-create-booking-button',
    ResDiaryToStep2Button = 'resdiary-to-step-2-button',
    ResDiaryToStep3Button = 'resdiary-to-step-3-button',
    ReservationActionLog = 'reservation-action-log',
    ReservationLink = 'reservation-link',
    ReservationModuleAveragePriceToggle = 'reservation-module-average-price-toggle',
    ReservationModuleGuestDialog = 'guest-dialog',
    ReservationModuleResourceDialog = 'resource-dialog',
    Reservations = 'reservations',
    ResourceFilterNewReservationScreen = 'resource-filter-nrs',
    ResourceFilterReservationModule = 'resource-filter-reservation-module',
    ResourceStatusChart = 'resource-status-chart',
    Resources = 'resources',
    ResourcesBulkCreateSubmitButton = 'resources-bulk-create-submit-button',
    ResourcesBulkEditSubmitButton = 'resources-bulk-edit-submit-button',
    RestrictionCalendarBodyCell = 'restriction-calendar-body-cell',
    RestrictionCalendarCard = 'restriction-calendar-card',
    RestrictionCalendarSidebarDeleteButton = 'restriction-calendar-sidebar-delete-button',
    RestrictionCalendarSidebarEditButton = 'restriction-calendar-sidebar-edit-button',
    RestrictionDetail = 'restriction-detail',
    RoutingRulesAccountingCategoriesDialogCancel = 'routing-rules-accounting-categories-dialog-cancel',
    RoutingRulesAccountingCategoriesDialogSave = 'routing-rules-accounting-categories-dialog-save',
    RoutingRulesAccountingCategoriesEditButton = 'routing-rules-accounting-categories-edit-button',
    RoutingRulesCompaniesDialogCancel = 'routing-rules-companies-dialog-cancel',
    RoutingRulesCompaniesDialogSave = 'routing-rules-companies-dialog-save',
    RoutingRulesCompaniesEditButton = 'routing-rules-companies-edit-button',
    RoutingRulesCompaniesProfiles = 'routing-rules-companies-profiles',
    RoutingRulesConflictsCompanies = 'routing-rules-conflicts-companies',
    RoutingRulesConflictsDialogCancel = 'routing-rules-conflicts-dialog',
    RoutingRulesConflictsRates = 'routing-rules-conflicts-rates',
    RoutingRulesConflictsServices = 'routing-rules-conflicts-services',
    RoutingRulesConflictsTravelAgencies = 'routing-rules-conflicts-travel-agencies',
    RoutingRulesCurrentConflictsSection = 'routing-rules-current-conflicts-section',
    RoutingRulesDetailsDialogTitle = 'routing-rules-details-dialog-title',
    RoutingRulesExistingConflictsCompanies = 'routing-rules-existing-conflicts-companies',
    RoutingRulesExistingConflictsRates = 'routing-rules-existing-conflicts-rates',
    RoutingRulesExistingConflictsSection = 'routing-rules-existing-conflicts-section',
    RoutingRulesExistingConflictsServices = 'routing-rules-existing-conflicts-services',
    RoutingRulesExistingConflictsTravelAgencies = 'routing-rules-existing-conflicts-travel-agencies',
    RoutingRulesProductCategoriesDialogCancel = 'routing-rules-product-categories-dialog-cancel',
    RoutingRulesProductCategoriesDialogSave = 'routing-rules-product-categories-dialog-save',
    RoutingRulesProductCategoriesEditButton = 'routing-rules-product-categories-edit-button',
    RoutingRulesProductsDialogCancel = 'routing-rules-products-dialog-cancel',
    RoutingRulesProductsDialogSave = 'routing-rules-products-dialog-save',
    RoutingRulesProductsEditButton = 'routing-rules-products-edit-button',
    RoutingRulesRatesDialogCancel = 'routing-rules-rates-dialog-cancel',
    RoutingRulesRatesDialogSave = 'routing-rules-rates-dialog-save',
    RoutingRulesRatesEditButton = 'routing-rules-rates-edit-button',
    RoutingRulesRatesField = 'routing-rules-rates-field',
    RoutingRulesTravelAgenciesProfiles = 'routing-rules-travel-agencies-profiles',
    SearchBooker = 'search-booker',
    SearchCompany = 'search-company',
    SearchCustomer = 'search-customer',
    SearchGroup = 'search-group',
    SearchTravelAgency = 'search-travel-agency',
    SearchTravelAgencyNumber = 'search-travel-agency-number',
    SelectBusinessSegment = 'select-business-segment',
    SelectConfirmation = 'select-confirmation',
    SelectConfirmationLanguage = 'select-confirmation-language',
    SelectOrigin = 'select-origin',
    SelectProduct = 'select-product',
    SelectReleaseDate = 'select-release-date',
    SelectReservationPurpose = 'select-reservation-purpose',
    SelectServiceToBook = 'select-service',
    SelectStatus = 'select-status',
    SelectVoucher = 'select-voucher',
    SendReminderSendButton = 'send-reminder-send-button',
    ServiceSelector = 'service-selector',
    SettingsMenu = 'settings-menu',
    SignInEmail = 'sign-in-email',
    SignInMarketingLink = 'SignInMarketingLink',
    SignInPasskeyLink = 'sign-in-passkey-link',
    SignInPassword = 'sign-in-password',
    SignInSsoLink = 'sign-in-sso-link',
    SmartDetailManageReservationButton = 'smart-detail-manage-reservation-button',
    SmartDetailNotesExpandButton = 'smart-detail-notes-expand-button',
    SmartDetailTotalBalance = 'smart-detail-total-balance',
    SpaceCategory = 'space-category',
    StartDate = 'start-date',
    TableActionDelete = 'table-action-delete',
    TableActionEdit = 'table-action-edit',
    TaskStatisticsChart = 'task-statistics-chart',
    UndoButton = 'undo-button',
    UserConsentButton = 'user-consent-button',
    UserMenuAvatar = 'user-menu-avatar',
    VerificationPhotoConfirmDeleteButton = 'verification-photo-confirm-delete-button',
    VerificationPhotoDetailIcon = 'verification-photo-detail-icon',
    VerificationPhotoDownloadIcon = 'verification-photo-download-icon',
    WelcomeToBIPrimaryBtn = 'welcome-to-bi-primary-btn',
    WelcomeToBISkipBtn = 'welcome-to-bi-skip-btn',
}

export default DataTestId;
